import type { DirectoryUserRecord } from '../directory/DirectoryApiService';
import { strategyFor } from './IdpHierarchyStrategy';

export const DEFAULT_CLASSIFICATION_LEVELS: string[] = ['department'];

function nonEmpty(value: string | null | undefined): string | null {
    return typeof value === 'string' && value.trim().length > 0 ? value.trim() : null;
}

function strategyLevel(providerTypeId: string, user: DirectoryUserRecord, levelName: string): string | null {
    const strategy = strategyFor(providerTypeId);
    const index = strategy.levelNames.indexOf(levelName);
    if (index < 0) return null;
    return strategy.levels(user)[index]?.label ?? null;
}

export function extractDimension(key: string, user: DirectoryUserRecord, providerTypeId: string): string | null {
    switch (key) {
        case 'department':
            return strategyLevel(providerTypeId, user, 'Department') ?? nonEmpty(user.department);
        case 'title':
            return nonEmpty(user.title);
        case 'costCenter':
            return nonEmpty(user.costCenter);
        case 'user':
            return nonEmpty(user.displayName);
        case 'businessUnit':
            return strategyLevel(providerTypeId, user, 'Business unit');
        case 'team':
            return strategyLevel(providerTypeId, user, 'Team');
        default:
            return null;
    }
}
